import React from 'react';

import SelectInput from './input/SelectInput.js';
import CheckboxInput from './input/CheckboxInput.js';
import DateInput from './input/DateInput.js';
import RichTextInput from './input/RichTextInput.js';
import ImageInput from './input/ImageInput.js';
import AddressInput from './input/AddressInput.js';
import IntervalInput from './input/IntervalInput.js';
import TextInput from './input/TextInput.js';
import ScanInput from './input/ScanInput.js';
import ChangeInput from './input/ChangeInput.js';
import CourierRewardsInput from './input/CourierRewardsInput.js';

export default class FlexibleInput extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  render = () => {
    var properties = this.props.objectProperties[this.props.objectKey];
    switch (properties.type) {
      case "text":
      case "password":
      case "textarea":
        return <TextInput  properties={properties} {...this.props} />
      case "scan":
        return <ScanInput  properties={properties} {...this.props} />
      case "wysiwyg":
        return <RichTextInput properties={properties} {...this.props} />
      case "select":
      case "multi":
        return <SelectInput properties={properties} {...this.props} />
      case "checkbox":
        return <CheckboxInput properties={properties} {...this.props} />
      case "date":
        return <DateInput properties={properties} {...this.props} />
      case "date-interval":
      case "interval":
        return <IntervalInput properties={properties} {...this.props} />
      case "address":
        return <AddressInput properties={properties} {...this.props} />
      case "image":
      case "image-crop":
        return <ImageInput properties={properties} {...this.props} />
      case "change":
        return <ChangeInput properties={properties} {...this.props} />
      case "courier-rewards":
        return <CourierRewardsInput properties={properties} {...this.props} />
      default:
        return <input/>
    }
  }
}



// WEBPACK FOOTER //
// ./src/FlexibleInput.js